import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Spacer } from '@perch-labs/shrike';
import { routes, copyFor } from 'config';
import {
  GridPage,
  LeftSideOfPage,
  RightSideOfPage,
  Container,
  BackLinkCell,
} from 'styles';
import { BackLink } from 'components/back-link';
import { Explainer } from 'pages/advocacy/components/explainer';
import { Representatives } from './representatives/representatives.component';
import { EmailForm } from './email-form/email-form.component';
import { Address } from './address/address.component';

const getBackLinkCopy = copyFor('navigation.backLink.dashboardLocations');

export const Message = () => {
  const history = useHistory();
  const { utilityAccountId } = useParams<{ utilityAccountId?: string }>();
  const { advocacyAddress, advocacySuccess } = routes({ utilityAccountId });

  return (
    <GridPage>
      <BackLinkCell>
        <BackLink
          to={advocacyAddress}
          location={getBackLinkCopy('advocacyAddress')}
        />
      </BackLinkCell>
      <LeftSideOfPage>
        <Container flex justifyContent="center">
          <EmailForm onSuccess={() => history.push(advocacySuccess)} />
        </Container>
      </LeftSideOfPage>
      <RightSideOfPage>
        <Container maxWidth="600px" width="100%">
          <Explainer />
          <Spacer />
          <Address />
          <Spacer />
          <Representatives />
        </Container>
      </RightSideOfPage>
    </GridPage>
  );
};
